/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 照会用リクエスト情報
 */
export interface EventReferRequestDto { 
    /**
     * イベントID(前方一致)：半角数字
     */
    eventId?: string;
    /**
     * イベント種別(前方一致)：半角
     */
    eventType?: string;
    /**
     * イベントステータス：半角数字
     */
    eventStatus?: string;
    /**
     * イベント受付日時(From)：日付(yyyyMMddHHmm)
     */
    eventReceptionDateTimeFrom?: string;
    /**
     * イベント受付日時(To)：日付(yyyyMMddHHmm)
     */
    eventReceptionDateTimeTo?: string;
    /**
     * 業務リクエストID(前方一致)：半角
     */
    businessRequestId?: string;
    /**
     * 最終更新日時(From)：日付(yyyyMMddHHmm)
     */
    lastUpdateTimeFrom?: string;
    /**
     * 最終更新日時(To)：日付(yyyyMMddHHmm)
     */
    lastUpdateTimeTo?: string;
}

